var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"col",attrs:{"align-x":"center"}},[_c('table',[_vm._m(0),_vm._l((_vm._list),function(item,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(item.email))]),_c('td',[_vm._v(_vm._s(_vm._f("roleLabel")(item.roles)))])])})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{staticClass:"theme_text"},[_vm._v("信箱")]),_c('th')])
}]

export { render, staticRenderFns }